var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filter-speed-template',[_c('v-row',[_c('v-checkbox',{staticClass:"mr-3 body",attrs:{"label":"Ignorar transações sistêmicas"},model:{value:(_vm.payload.IgnoreClientVaultTransactions),callback:function ($$v) {_vm.$set(_vm.payload, "IgnoreClientVaultTransactions", $$v)},expression:"payload.IgnoreClientVaultTransactions"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }